import { couponsPathTo } from './Api';

export const PENDING_COUPON_KEY = 'pending_coupon_code';

export const couponShareUrl = (code) => `${window.location.origin}/coupons/${code}`;

export const getPendingCouponCode = () => localStorage.getItem(PENDING_COUPON_KEY);

export const setPendingCouponCode = (code) => {
  if (!code) return;
  localStorage.setItem(PENDING_COUPON_KEY, String(code).toUpperCase());
};

export const clearPendingCouponCode = () => {
  localStorage.removeItem(PENDING_COUPON_KEY);
};

export const couponDiscountAmount = (preChargeCents, coupon) => {
  if (!coupon) return 0;

  const pre = Math.max(Number(preChargeCents) || 0, 0);
  if (pre <= 0) return 0;

  const value = Number(coupon.discount_value || 0);
  let amount = 0;

  if (coupon.discount_type === 'percent') {
    amount = Math.floor((pre * value) / 100);
    const cap = coupon.max_discount_cents;
    if (cap != null && cap !== '') {
      amount = Math.min(amount, Number(cap));
    }
  } else {
    amount = value;
  }

  return Math.max(Math.min(amount, pre), 0);
};

export const claimPendingCoupon = async () => {
  const code = getPendingCouponCode();
  if (!code) return { claimed: false };

  try {
    const result = await couponsPathTo.redeem(code);
    clearPendingCouponCode();
    return { claimed: true, coupon: result.data };
  } catch (error) {
    const message = error?.response?.data?.errors?.[0];
    if (message && /já resgatou/i.test(message)) {
      clearPendingCouponCode();
    }
    return { claimed: false, error: message || 'Não foi possível resgatar o cupom.' };
  }
};

export const claimPendingCouponWithFeedback = async (openSnackbar) => {
  const result = await claimPendingCoupon();
  if (result.claimed) {
    const name = result.coupon?.name;
    openSnackbar(name ? `Cupom ${name} resgatado!` : 'Cupom resgatado!', 'success');
  } else if (result.error) {
    openSnackbar(result.error, 'error');
  }
  return result;
};
